import { SagaIterator } from 'redux-saga';
import { CertifyHosLogPayload, MultipleLogIdsPayload } from 'src/common/types';
import apiClient from '../common/apiClient';

export function certifyHosLog(payload: CertifyHosLogPayload): SagaIterator {
  return apiClient.patch(`/eld/logs/${payload.logDate}/certify`);
}

export function multiplyCertifyHosLogs(payload: MultipleLogIdsPayload): SagaIterator {
  return apiClient.patch(`/eld/logs/bulk/certify`, payload);
}
